import { render, staticRenderFns } from "./BoardSuperAdmin.vue?vue&type=template&id=7a056528&"
import script from "./BoardSuperAdmin.vue?vue&type=script&lang=js&"
export * from "./BoardSuperAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports